export const DDMMMYYYY = 'DD-MMM-YYYY';
export const DD_SP_MMM_SP_YYYY = 'DD MMM YYYY';
export const DDMMM_COMMA_YYYY = 'DD MMM, YYYY';
